export const COLORS = [
	'#FF7800',
	'#ff5722',
	'#d943a2',
	'#a292ed',
	'#9c27b0',
	'#5F259F',
	'#3949ab',
	'#FF7800',
	'#13d3ff',
	'#8dcb7e',
	'#00bfb3',
	'#5A5A5A',
];
